import { useState } from "react";

import { AbstractTooltip as Tooltip } from "../ToolTip/ToolTip";

import styles from "./notificationsPanel.module.css";
import AssetUpdateModal from "../AssetUpdateModal";

interface NotificationsPanelProps {
  newNotifications: boolean;
  lessonVersionId?: number;
}

interface NotificationsPopupProps {
  visible: boolean;
  handleClose: () => void;
  lessonVersionId?: number;
}

export default function NotificationsPanel({ newNotifications, lessonVersionId }: Readonly<NotificationsPanelProps>) {
  const [showPopup, setShowPopup] = useState(false);

  const iconClassName = newNotifications ? styles.newNotifications : styles.notifications;

  function closePopup() {
    setShowPopup(false);
  }

  return (
    <div className={`icons-wrapper ${styles.notificationsWrapper}`} data-tooltip-id="notifications">
      <button
        aria-label="Notifications"
        className={`header-icon ${styles.notificationsButton} ${iconClassName}`}
        onClick={() => {
          if (newNotifications) {
            setShowPopup((prev) => !prev);
          }
        }}
      />
      <p style={{ color: "var(--icon-header-color)", userSelect: "none" }}>&nbsp;</p>
      <NotificationsPopup visible={showPopup} handleClose={closePopup} lessonVersionId={lessonVersionId} />
      {!newNotifications && <Tooltip id="notifications" />}
    </div>
  );
}

function NotificationsPopup({ visible, handleClose, lessonVersionId }: Readonly<NotificationsPopupProps>) {
  const [showAssetUpdateModal, setShowAssetUpdateModal] = useState(false);

  if (!visible && !showAssetUpdateModal) {
    return null;
  }

  function handleAssetUpdate() {
    setShowAssetUpdateModal(true);
    handleClose();
  }

  if (showAssetUpdateModal) {
    return (
      <AssetUpdateModal
        open={showAssetUpdateModal}
        onClose={() => {
          setShowAssetUpdateModal(false);
        }}
        lessonVersionId={lessonVersionId}
      />
    );
  }

  return (
    <dialog aria-label="Notifications popup" aria-hidden="false" className={styles.notificationPopup}>
      <div>
        <p>Asset Notification</p>
        <button onClick={handleClose}>&times;</button>
      </div>
      <div>
        <p>There have been asset updates.</p>
        <button onClick={handleAssetUpdate}>Check Updates</button>
      </div>
    </dialog>
  );
}
